import React, {useRef} from "react";
import {IconArrowBack} from "../../../../../icons/IconArrowBack";
import {useLocation, useNavigate} from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import {RegularCopyAlt} from "../../../../../icons/RegularCopyAlt";
import "./style.css";

export const PixieCardDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const colors = useDynamicColors();

  const handleButtonBack = () => {
    const currentParams = location.search;
    navigate(`/vxlab-landing-pixie-mobile${currentParams}`);
  };

  return (
      <div className="pixie-card-details" ref={scrollRef}>
        <div className="overlap-wrapper-2">
          <div className="overlap-6">
            <div className="frame-wrapper">
              <div className="frame-28">
                <div className="subtitle">Card details</div>
                <div onClick={handleButtonBack} style={{ cursor: "pointer" }}>
                  <IconArrowBack className="icon-arrow-back" color="white" />
                </div>
              </div>
            </div>

            <div className="frame-29">
              <div className="frame-30">
                <div className="overlap-7">
                  <div
                      className="group-5"
                      style={{
                        borderRadius: 8,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundSize: "contain",
                        backgroundImage: colors.url_card
                            ? `url(${colors.url_card})`
                            : "none",
                        backgroundColor: colors.url_card
                            ? "transparent"
                            : "rgb(255, 255, 25, 0.1)",
                      }}
                  >
                    {/* <img
                    className="logo-visa"
                    alt="Logo visa"
                    src="/img/logo-visa.svg"
                  /> */}

                    <div className="overlap-8">
                      <div className="group-6">
                        <div className="overlap-group-12">
                          {/* <img
                          className="image-7"
                          alt="Image"
                          src="/img/image-62001.png"
                        /> */}
                          {/*
                        <div className="rectangle-10" /> */}
                          {/*
                        <div className="rectangle-11" />

                        <div className="rectangle-12" /> */}
                        </div>
                      </div>

                      <div className="frame-31">
                        <div className="frame-32">
                          <div className="text-wrapper-32">Pay date</div>

                          <div className="text-wrapper-33">10 ABR</div>
                        </div>

                        <div className="frame-32">
                          <div className="text-wrapper-32">Due date</div>

                          <div className="text-wrapper-33">11/30</div>
                        </div>
                      </div>

                      <div className="frame-33">
                        <div className="text-wrapper-34">7531 4532 6643 5849</div>

                        <RegularCopyAlt className="regular-copy-alt" />
                      </div>
                    </div>
                  </div>

                  <div className="bottom">
                    <div className="fecha-pago">
                      <div className="text-wrapper-35">Available (USD)</div>

                      <div className="frame-34">
                        <div className="text-wrapper-36">13,000</div>
                      </div>
                    </div>

                    <div className="cupo-dispo">
                      <div className="text-wrapper-37">Assigned (USD)</div>

                      <div className="text-wrapper-38">23,000</div>
                    </div>

                    {/* <div className="ver-dato">
                    <div className="text-wrapper-39">Hide</div>

                    <Icons9 className="icons-9" />
                  </div> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="frame-35">
              <div className="div-8">
                <div className="diamond-text">
                  <svg
                      width={86}
                      height={86}
                      viewBox="0 0 86 86"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M8.66443 50.619C4.30097 46.2556 4.30096 39.181 8.66443 34.8175L43.2022 0.279733L77.74 34.8175C82.1034 39.181 82.1034 46.2556 77.74 50.619L43.2022 85.1568L8.66443 50.619Z"
                        fill={colors.cuaternario}
                    />
                    <path
                        d="M49.483 47.9705C49.483 55.6891 43.3335 61.9411 35.7415 61.9411C28.1495 61.9411 22 55.6891 22 47.9705C22 40.252 28.1495 34 35.7415 34C43.3335 34 49.483 40.252 49.483 47.9705Z"
                        fill={colors.primario}
                    />
                    <path
                        d="M49.3338 34.5002L54.3338 39.5002L60.1671 33.6668L55.1671 28.6668L49.3338 34.5002Z"
                        fill={colors.septimo}
                    />
                    <path
                        d="M58.5005 25.3335L55.1671 28.6668M55.1671 28.6668L60.1671 33.6668L54.3338 39.5002L49.3338 34.5002M55.1671 28.6668L49.3338 34.5002M42.4838 41.3502C43.3444 42.1993 44.0285 43.2102 44.4967 44.3248C44.965 45.4394 45.2081 46.6356 45.2122 47.8445C45.2162 49.0535 44.9811 50.2513 44.5203 51.369C44.0595 52.4867 43.3822 53.5022 42.5274 54.3571C41.6725 55.2119 40.657 55.8892 39.5393 56.35C38.4216 56.8108 37.2238 57.0459 36.0148 57.0419C34.8059 57.0378 33.6097 56.7947 32.4951 56.3264C31.3805 55.8582 30.3696 55.1741 29.5205 54.3135C27.8507 52.5846 26.9267 50.2691 26.9476 47.8656C26.9685 45.4622 27.9325 43.1631 29.6321 41.4635C31.3317 39.7639 33.6308 38.7999 36.0343 38.779C38.4377 38.7581 40.7533 39.682 42.4821 41.3518L42.4838 41.3502ZM42.4838 41.3502L49.3338 34.5002"
                        stroke="#2222E3"
                        strokeWidth={3.63636}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                  </svg>

                  <div className="text-wrapper-40">CVV</div>
                </div>

                <div className="diamond-text">
                  <div className="btn-diamond-img-2">
                    <div className="pin-code-wrapper">
                      <div className="pin-code">
                        <div className="group-7">
                          <div className="overlap-group-13">
                            <svg
                                width={39}
                                height={39}
                                viewBox="0 0 39 39"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                  d="M38.6946 29.5462C38.6946 34.262 34.8748 38.0817 30.159 38.0817C25.4433 38.0817 21.6235 34.262 21.6235 29.5462C21.6235 24.8304 25.4433 21.0106 30.159 21.0106C34.8748 21.0106 38.6946 24.8304 38.6946 29.5462Z"
                                  fill={colors.septimo}
                              />
                              <circle
                                  cx={10.8775}
                                  cy={23.6807}
                                  r={1.96974}
                                  fill={colors.terciario}
                              />
                              <ellipse
                                  cx={17.5964}
                                  cy={23.6807}
                                  rx={2.0354}
                                  ry={1.96974}
                                  fill={colors.terciario}
                              />
                              <circle
                                  cx={24.3155}
                                  cy={23.6807}
                                  r={1.96974}
                                  fill={colors.terciario}
                              />
                              <path
                                  d="M30.4874 12.7213H27.7735V9.27592C27.7735 4.16118 23.5125 0 18.275 0C13.0375 0 8.77643 4.16118 8.77643 9.27592V12.7213H6.06256C3.81792 12.7213 1.99176 14.5046 1.99176 16.6967V29.948C1.99176 32.14 3.81792 33.9234 6.06256 33.9234H30.4874C32.732 33.9234 34.5582 32.14 34.5582 29.948V16.6967C34.5582 14.5046 32.732 12.7213 30.4874 12.7213ZM11.4903 9.27592C11.4903 5.62253 14.5339 2.65026 18.275 2.65026C22.016 2.65026 25.0596 5.62253 25.0596 9.27592V12.7213H11.4903V9.27592ZM31.8443 29.948C31.8443 30.6786 31.2356 31.2731 30.4874 31.2731H6.06256C5.31435 31.2731 4.70563 30.6786 4.70563 29.948V16.6967C4.70563 15.966 5.31435 15.3715 6.06256 15.3715H30.4874C31.2356 15.3715 31.8443 15.966 31.8443 16.6967V29.948Z"
                                  fill="#2222E3"
                              />
                              <path
                                  d="M11.4903 9.27592C11.4903 5.62253 14.5339 2.65026 18.275 2.65026C22.016 2.65026 25.0596 5.62253 25.0596 9.27592V12.7213H11.4903V9.27592Z"
                                  fill={colors.primario}
                              />
                            </svg>
                            <div className="frame-36"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="text-wrapper-40">Missing</div>
                </div>

                <div className="diamond-text">
                  <svg
                      width={86}
                      height={86}
                      viewBox="0 0 86 86"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M8.69568 51.0013C4.33222 46.6379 4.33221 39.5633 8.69568 35.1998L43.4014 0.494093L78.1071 35.1998C82.4706 39.5633 82.4706 46.6379 78.1072 51.0013L43.4014 85.7071L8.69568 51.0013Z"
                        fill={colors.cuaternario}
                    />
                    <path
                        d="M57.442 43.5337L48.2352 34.3269C47.3656 33.4574 47.3656 32.0635 48.2352 31.2068L57.442 22L66.6488 31.2068C67.5183 32.0763 67.5183 33.4701 66.6488 34.3269L57.442 43.5337Z"
                        fill={colors.septimo}
                    />
                    <path
                        d="M43.3173 45.3687C42.6963 45.4233 41.8625 45.2412 41.5419 44.8434C40.9909 44.1593 39.9898 44.0515 39.3057 44.6025C38.6216 45.1535 38.5138 46.1546 39.0647 46.8387C39.6727 47.5936 40.5102 48.0559 41.3658 48.3083C41.571 48.9491 42.1717 49.4131 42.8807 49.4131C43.5505 49.4131 44.1236 48.999 44.3579 48.4129C45.9591 48.0224 47.07 46.8767 47.2644 45.3463C47.5006 43.4859 46.3109 41.7076 44.3713 41.022C43.1576 40.5929 42.5428 40.3413 42.3707 40.2601C42.1336 40.1483 42.1398 40.0652 42.1442 40.0046C42.1564 39.8404 42.2782 39.6876 42.3544 39.6647C43.2395 39.398 43.7093 39.6733 43.781 39.7579C44.2862 40.4746 45.2764 40.6472 45.9944 40.1434C46.7134 39.6389 46.8872 38.647 46.3826 37.9281C45.9703 37.3404 45.2875 36.8309 44.412 36.5655C44.2242 35.8964 43.6097 35.4058 42.8806 35.4058C42.1196 35.4058 41.4834 35.9403 41.327 36.6544C40.0189 37.0989 39.0783 38.3362 38.972 39.7695C38.8658 41.2026 39.6482 42.4931 41.0138 43.1371C41.4003 43.3194 42.2377 43.6417 43.311 44.021C43.9491 44.2466 44.1391 44.7079 44.1088 44.9457C44.0679 45.2686 43.5417 45.349 43.3173 45.3687Z"
                        fill={colors.primario}
                    />
                    <path
                        d="M61.7694 41.9748C62.6478 41.9748 63.3598 41.2627 63.3598 40.3844V33.8948C63.3598 30.387 60.506 27.5332 56.9982 27.5332H29.0071C25.4993 27.5332 22.6455 30.387 22.6455 33.8948V50.9244C22.6455 54.4321 25.4993 57.286 29.0071 57.286H56.9982C60.506 57.286 63.3598 54.4321 63.3598 50.9244V48.3905C63.3598 47.7517 62.9775 47.1747 62.389 46.9258L62.2543 46.8688C62.1734 46.8346 62.0897 46.8071 62.0042 46.7867C61.4295 46.6493 60.8365 46.5797 60.2417 46.5797C56.0848 46.5797 52.7008 49.9525 52.6822 54.1052H33.3231C33.3048 49.9734 29.9546 46.6137 25.8263 46.58V38.3917C29.9659 38.358 33.3231 34.9799 33.3231 30.8326C33.3231 30.7931 33.3228 30.7535 33.3222 30.714H52.6831C52.6825 30.7535 52.6822 30.7931 52.6822 30.8326C52.6822 34.9799 56.0394 38.358 60.179 38.3917V40.3844C60.179 41.2627 60.891 41.9748 61.7694 41.9748ZM60.179 49.761V50.9244C60.179 52.6782 58.7521 54.1052 56.9982 54.1052H55.8631C55.8813 51.7273 57.8047 49.7945 60.179 49.761ZM30.1422 54.1052H29.0071C27.2532 54.1052 25.8263 52.6782 25.8263 50.9244V49.761C28.2006 49.7945 30.124 51.7273 30.1422 54.1052ZM30.1423 30.8326C30.1423 33.226 28.212 35.1772 25.8263 35.2108V33.8948C25.8263 32.1409 27.2532 30.714 29.0071 30.714H30.1408C30.1418 30.7534 30.1423 30.7931 30.1423 30.8326ZM55.863 30.8326C55.863 30.793 55.8635 30.7534 55.8645 30.714H56.9982C58.7521 30.714 60.179 32.1409 60.179 33.8948V35.2108C57.7934 35.1772 55.863 33.226 55.863 30.8326Z"
                        fill={colors.terciario}
                    />
                    <path
                        d="M30.1423 30.8326C30.1423 33.226 28.212 35.1772 25.8263 35.2108V33.8948C25.8263 32.1409 27.2532 30.714 29.0071 30.714H30.1408C30.1418 30.7534 30.1423 30.7931 30.1423 30.8326Z"
                        fill={colors.primario}
                    />
                    <path
                        d="M30.1422 54.1052H29.0071C27.2532 54.1052 25.8263 52.6782 25.8263 50.9244V49.761C28.2006 49.7945 30.124 51.7273 30.1422 54.1052Z"
                        fill={colors.primario}
                    />
                    <path
                        d="M60.179 49.761V50.9244C60.179 52.6782 58.7521 54.1052 56.9982 54.1052H55.8631C55.8813 51.7273 57.8047 49.7945 60.179 49.761Z"
                        fill={colors.primario}
                    />
                  </svg>

                  <div className="text-wrapper-40">Pay</div>
                </div>

                <div className="diamond-text">
                  <svg
                      width={86}
                      height={86}
                      viewBox="0 0 86 86"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M8.1576 51.0013C3.79413 46.6379 3.79413 39.5633 8.15759 35.1998L42.8633 0.494093L77.5691 35.1998C81.9325 39.5633 81.9325 46.6379 77.5691 51.0013L42.8633 85.7071L8.1576 51.0013Z"
                        fill={colors.cuaternario}
                    />
                    <path
                        d="M26.5505 45.8667C28.1706 45.8667 29.4839 44.5534 29.4839 42.9333C29.4839 41.3133 28.1706 40 26.5505 40C24.9305 40 23.6172 41.3133 23.6172 42.9333C23.6172 44.5534 24.9305 45.8667 26.5505 45.8667Z"
                        fill="#2222E3"
                    />
                    <path
                        d="M42.6833 45.8667C44.3034 45.8667 45.6167 44.5534 45.6167 42.9333C45.6167 41.3133 44.3034 40 42.6833 40C41.0633 40 39.75 41.3133 39.75 42.9333C39.75 44.5534 41.0633 45.8667 42.6833 45.8667Z"
                        fill="#2222E3"
                    />
                    <path
                        d="M58.8171 45.8667C60.4372 45.8667 61.7505 44.5534 61.7505 42.9333C61.7505 41.3133 60.4372 40 58.8171 40C57.1971 40 55.8838 41.3133 55.8838 42.9333C55.8838 44.5534 57.1971 45.8667 58.8171 45.8667Z"
                        fill="#2222E3"
                    />
                  </svg>

                  <div className="text-wrapper-40">More</div>
                </div>
              </div>

              <div className="frame-37">
                <div className="div-8">
                  <div className="title-3">Last Transactions</div>

                  <div className="frame-38">
                    <div className="btn-text-link">
                      <div className="text-wrapper-41">See all</div>

                      <svg
                          width={24}
                          height={25}
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M9.75 17.2905L14.25 12.7905L9.75 8.29053"
                            stroke="#01087F"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="frame-39">
                  <div className="movements-2">
                    <div className="frame-40">
                      <div className="overlap-group-wrapper-2">
                        <div className="overlap-group-14">
                          <div className="rectangle-13" />

                          <img
                              className="img-2"
                              alt="Dinner"
                              src="/img/dinner.svg"
                          />
                        </div>
                      </div>

                      <div className="frame-41">
                        <div className="text-wrapper-42">
                          Starbucks coffee time
                        </div>

                        <img
                            className="btn-icon-chevron"
                            alt="Btn icon chevron"
                            src="/img/btn-icon-chevron-1.svg"
                        />
                      </div>
                    </div>

                    <div className="frame-42">
                      <div className="date-2">11/06/22</div>

                      <div className="amount-2">- $25.11</div>
                    </div>
                  </div>

                  <div className="movements-2">
                    <div className="frame-40">
                      <div className="overlap-group-wrapper-2">
                        <div className="overlap-group-14">
                          <div className="rectangle-13" />

                          <img className="img-2" alt="Paw" src="/img/paw.svg" />
                        </div>
                      </div>

                      <div className="frame-34">
                        <div className="text-wrapper-42">Bruno’s tricks</div>

                        <img
                            className="btn-icon-chevron"
                            alt="Btn icon chevron"
                            src="/img/btn-icon-chevron-1.svg"
                        />
                      </div>
                    </div>

                    <div className="frame-42">
                      <div className="date-2">11/06/22</div>

                      <div className="amount-2">- $12.42</div>
                    </div>
                  </div>

                  <div className="movements-2">
                    <div className="frame-40">
                      <div className="overlap-group-wrapper-2">
                        <div className="overlap-group-14">
                          <div className="rectangle-13" />

                          <img
                              className="shopping-bag"
                              alt="Shopping bag"
                              src="/img/shopping-bag.svg"
                          />
                        </div>
                      </div>

                      <div className="frame-34">
                        <div className="text-wrapper-42">New gymn shoes</div>

                        <img
                            className="btn-icon-chevron"
                            alt="Btn icon chevron"
                            src="/img/btn-icon-chevron-1.svg"
                        />
                      </div>
                    </div>

                    <div className="frame-42">
                      <div className="date-2">11/06/22</div>

                      <div className="amount-2">- $158.68</div>
                    </div>
                  </div>

                  <div className="movements-2" style={{ border: "none" }}>
                    <div className="frame-40">
                      <div className="overlap-group-wrapper-2">
                        <div className="overlap-group-14">
                          <div className="rectangle-14" />

                          <img
                              className="credit-card"
                              alt="Credit card"
                              src="/img/credit-card.svg"
                          />
                        </div>
                      </div>

                      <div className="text-wrapper-43">Card payment</div>
                    </div>

                    <div className="frame-42">
                      <div className="date-2">11/06/22</div>

                      <div className="amount-3">$950.23</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
